import React from 'react'

const ActiveTagBar = () => {
  return <hr className="bg-blue50 rounded-xl w-1 h-6 border" />
}

export default ActiveTagBar
